var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionSmallRefreshDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IPM/icon/refresh") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IPM/icon/refresh",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(4, 4.8)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_refresh_48px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9661038,2.2325 C11.5924953,0.855 9.69606004,0 7.59524703,0 C3.39362101,0 0,3.401 0,7.6 C0,11.799 3.39362101,15.2 7.59524703,15.2 C11.1362101,15.2 14.1020638,12.7775 14.9433396,9.5 L12.9661038,9.5 C12.1818637,11.7135 10.0810507,13.3 7.59524703,13.3 C4.44402752,13.3 1.8916823,10.74925 1.8916823,7.6 C1.8916823,4.45075 4.44402752,1.9 7.59524703,1.9 C9.1684803,1.9 10.5801126,2.5555 11.6115072,3.58625 L8.54584115,6.65 L15.2,6.65 L15.2,0 L12.9661038,2.2325 Z",
    id: "Path"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallRefreshDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-small-refresh-default.0c5ffe793c6a82017dfa95565ee661f6.svg";